import { defineMessages } from 'react-intl';

export const locationResultCardContentMessages = defineMessages({
  orderChannel: {
    defaultMessage: `{channel, select,
      pickup {Pickup}
      delivery {Delivery}
      outpost {Outpost}
      other {}
    }`,
    description: 'Location Screen | Location Result Card | Order channel',
  },
  detailsLinkA11y: {
    defaultMessage: 'Open location details for {name}',
    description: 'Location Search | Result | Details Link | A11y',
  },
});
